/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DevicesUtilVM { 
    deviceName?: string | null;
    deviceType?: string | null;
    activeDays?: number;
    latestSyncDate?: string | null;
    createdAt?: string | null;
    lastScanDate?: string | null;
    eventTime?: string | null;
    schoolId?: number | null;
    deviceId?: number | null;
}

